<template>
  <b-card title="Capital Goods Invoice">
    <capital-goods-invoice-filter @filtersUpdated="filtersChangeHandler" />
    <capital-goods-invoice-list :filters="filters" />
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import CapitalGoodsInvoiceFilter from '@/components/Invoices/CapitalGoodsInvoice/CapitalGoodsInvoiceFilter.vue'
import CapitalGoodsInvoiceList from '@/components/Invoices/CapitalGoodsInvoice/CapitalGoodsInvoiceList.vue'

export default {
  components: {
    BCard,
    CapitalGoodsInvoiceFilter,
    CapitalGoodsInvoiceList,
  },
  data() {
    return {
      filters: {},
    }
  },
  methods: {
    filtersChangeHandler(filterData) {
      this.filters = filterData
    },
  },
}

</script>
